/**
 * Admin › Settings › Project fields (the single document in `defaults`).
 * - title, projectNumber, client, agency: the labels shown on every project. A blank one means the
 *   standard name.
 * - customField1–3: the names the three custom fields get on NEW projects. Each project keeps its own
 *   names, so changing these never alters an existing project (Aaron, 5 Nov 2026).
 * - showBudget, showCustomField1–3: whether those fields show on projects at all. Hiding one keeps what's
 *   filled in (Aaron, 6 Nov 2026). Missing means shown.
 */
export type DefaultsType = {
  title: string;
  projectNumber: string;
  client: string;
  agency: string;
  customField1?: string;
  customField2?: string;
  customField3?: string;
  showBudget?: boolean;
  showCustomField1?: boolean;
  showCustomField2?: boolean;
  showCustomField3?: boolean;
};

export type CustomFieldKey = 'customField1' | 'customField2' | 'customField3';
export type ShowKey = 'showBudget' | 'showCustomField1' | 'showCustomField2' | 'showCustomField3';

/** The standard names, used wherever a name is blank. */
export const STANDARD_FIELD_NAMES = {
  title: 'Title',
  projectNumber: 'Project number',
  client: 'Client',
  agency: 'Agency',
  customField1: 'Director',
  customField2: 'Producer',
  customField3: 'DOP',
};

export const CUSTOM_FIELDS: CustomFieldKey[] = ['customField1', 'customField2', 'customField3'];
export const showKeyFor = (k: CustomFieldKey): ShowKey =>
  k === 'customField1' ? 'showCustomField1' : k === 'customField2' ? 'showCustomField2' : 'showCustomField3';

/** Shown unless switched off. */
export const isShown = (defaults: Partial<DefaultsType> | undefined, key: ShowKey) => !defaults || defaults[key] !== false;
